import React from "react";
import { Link } from "react-router-dom";

function Project({ item }) {
	return (
		<>
			<div className="rounded overflow-hidden shadow-lg hover:shadow-xl group transform translate-y-0 hover:-translate-y-4 transition duration-300">
				<img
					className="w-full h-56"
					src={item?.image}
					alt={item?.title}
				/>
				<div className="mt-3 flex flex-wrap space-x-2">
					{item?.git &&
						item?.git?.map((code) => (
							<a
								href="/"
								target="_blank"
								rel="noreferrer"
								className="bg-gray-700 text-white px-2 rounded shaow text-sm flex items-center"
							>
								<i className="fab fa-github text-lg mr-1" />{" "}
								{code?.title}
							</a>
						))}
				</div>

				<div className="py-2">
					<div className="font-bold text-xl mb-2">
						<Link
							className="group-hover:underline"
							to={`project/${item?.id}/${item?.title}`}
						>
							{item?.title}
						</Link>{" "}
						{item?.url && (
							<a
								target="_blank"
								rel="noreferrer"
								href={item.url}
								className="text-sm text-gray-400 ml-2"
							>
								<i className="fas fa-external-link-alt" />
							</a>
						)}
					</div>
					<p className="text-gray-200 text-base">
						{item?.short_description}
					</p>
				</div>
				<div className="px-3 pt-2 pb-2">
					{item?.tags?.map((tag, index) => (
						<span key={index} className="tag">
							# {tag}
						</span>
					))}
				</div>
			</div>
		</>
	);
}

export default Project;
